<div class="col-6 row">
  <div class="col-4 details-key-main">
    <div class="col-12">
      Upload Files
    </div>
  </div>
  <div class="col-8">
    <div class="form-group col-12 paddingzero margin-bottom-0 row">
      <div class="col-12" [formGroup]="group">
        <kendo-fileselect [formControlName]="field.name">
        </kendo-fileselect>
      </div>
    </div>
  </div>
</div>
